import { PublicAccount } from "./VaultAccount";

export type VaultItem = {
  id: string;
  name: string;
  accounts: PublicAccount[];
  image: string;
  isActive?: boolean;
};
